var exports = {};

function quarticOut(t) {
  return Math.pow(t - 1, 3) * (1 - t) + 1;
}

exports = quarticOut;
export default exports;